import { compose, branch, renderComponent, withProps } from 'recompose'
import { connect } from 'react-redux'
import moment from 'moment'

import {
  withInitialData,
  subscriptionSelect
} from '../components/hoc'

import MDARSSoftwarePage from '../components/MDARSSoftware'
import MDARSSoftwareValidSubscription from '../components/MDARSSoftware/WithValidSubscription'


const mapStateToProps = (state, ownProps) => {
  const idsProducts = state.products.list.length ? state.products.list : ownProps.products
  return {
    idsProducts: idsProducts.filter(item => item.product_type.key === 'IDS'),
    mdarsProducts: idsProducts.filter(item => item.product_type.key === 'MDARS')    
  }
}

export default compose(
  connect(mapStateToProps, null),
  withProps({
    title: 'common:ids-page',
    contentImage: ''
  }),
  withInitialData,  
  subscriptionSelect,  
  branch(
    ({ user }) => {
      var valid = false

      if (user && user.mdars_exp_date) {
        if (moment().isAfter(moment(user.mdars_exp_date))) {
          if (user.ids_exp_date) {
            if (moment().isAfter(moment(user.ids_exp_date))) {
              valid = false
      }      
            else {
              valid = true
            }
          }
          else {
            valid = false
          }
        }
        else {
          valid = true
        }
      }
      else if (user && user.ids_exp_date) {
        if (moment().isAfter(moment(user.ids_exp_date))) {
          valid = false
        }
        else {
          valid = true
        }
      }
      else {
        valid = false
      }      
      return valid
    },
    renderComponent(MDARSSoftwareValidSubscription)
  )
)(MDARSSoftwarePage)



// WEBPACK FOOTER //
// ./pages/mdars-software.js